import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ReferenceDataUnit } from '@navfleet/client/reference-data/units/domain/models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ReferenceDataUnitsApi {
    private readonly http = inject(HttpClient);

    /**
     * get the backend default units of measure used for the different unit types
     * for now just get the list from a json file
     */
    public getBackendDataUnits(): Observable<ReferenceDataUnit[]> {
        return this.http.get<ReferenceDataUnit[]>('assets/backend-data-units/backend-data-units.json');
    }
}
